import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';

import { getSessionAuthToken } from '~/shared/auth/mountAuthHeaders';
import { PENDING_TICKET_SUMMARY_QUERY_KEY } from '~/shared/constants/queryKeys';
import { genomeApi } from '~/shared/services/api';

type PendingTicketSummaryResponse = { myRequests: boolean };

export async function getPendingTicketSummary() {
  const response = await genomeApi.get<PendingTicketSummaryResponse>(
    '/ticket/pending-summary'
  );

  return response.data;
}

export function useGetPendingTicketSummary() {
  const { data: session } = useSession();
  const token = getSessionAuthToken(session);

  return useQuery({
    queryKey: [PENDING_TICKET_SUMMARY_QUERY_KEY, token],
    queryFn: getPendingTicketSummary,
    enabled: Boolean(token),
  });
}
